(() => {
  const api = window.GutSuppCartGifts;
  if (!api || window.__gutSuppGiftUi) return;
  window.__gutSuppGiftUi = true;
  const root = window.Shopify?.routes?.root || '/';
  let purchasing = false;
  let locked = [];
  const status = message => document.querySelectorAll('.cro-cart-status').forEach(node => { node.textContent = message; });
  const render = (cart, open) => {
    const detail = { response: cart, handled: false, open };
    document.dispatchEvent(new CustomEvent('gutsupp:open-cart', { detail }));
    if (!detail.handled) throw new Error(api.config.error);
  };
  const request = async (path, body) => {
    const response = await fetch(root + path, { method: body === undefined ? 'GET' : 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, ...(body === undefined ? {} : {body: JSON.stringify(body)}) });
    const data = await response.json();
    if (!response.ok) {
      const error = new Error(data.description || api.config.error);
      error.status = response.status;
      throw error;
    }
    return data;
  };
  const canonical = properties => JSON.stringify(Object.entries(Array.isArray(properties) ? Object.fromEntries(properties) : properties || {}).sort(([a],[b]) => a.localeCompare(b)));
  const planId = item => String(item.selling_plan_allocation?.selling_plan?.id || item.selling_plan_allocation?.selling_plan_id || item.selling_plan_allocation?.selling_plan || '');
  const upgradePlans = {'42492248490081':7772995681,'42492248522849':7773028449};
  const changePlan = async (row, sellingPlan) => {
    const targetPlan = sellingPlan ? String(sellingPlan) : '';
    const sourcePlan = row.dataset.sellingPlanId || '';
    if (targetPlan === sourcePlan) return;
    const properties = canonical(JSON.parse(row.dataset.groupProperties || '{}'));
    const sameGroup = item => String(item.variant_id || item.id) === row.dataset.variantId && canonical(item.properties) === properties;
    const sum = items => items.reduce((total,item) => total + Number(item.quantity),0);
    let cart = await request('cart.js');
    const allSource = cart.items.filter(item => sameGroup(item) && planId(item) === sourcePlan);
    const selected = allSource.filter(item => row.dataset.aggregateParent === 'true' || item.key === row.dataset.itemKey);
    const selectedKeys = new Set(selected.map(item => item.key));
    const sourceRows = value => value.items.filter(item => sameGroup(item) && planId(item) === sourcePlan && (row.dataset.aggregateParent === 'true' || selectedKeys.has(item.key)));
    const targetQuantity = value => sum(value.items.filter(item => sameGroup(item) && planId(item) === targetPlan));
    if (!selected.length) {
      if (targetQuantity(cart)) return;
      throw new Error(api.config.error);
    }
    const sourceQuantity = sum(selected);
    const expectedTarget = targetQuantity(cart) + sourceQuantity;
    const expectedTotal = sum(allSource) + targetQuantity(cart);
    const expectedSource = sum(allSource) - sourceQuantity;
    let stalled = 0;
    while (sourceRows(cart).length) {
      const peer = sourceRows(cart)[0];
      const remaining = sum(sourceRows(cart));
      let failure;
      try {
        await request('cart/change.js',{id:peer.key,quantity:peer.quantity,selling_plan:sellingPlan || null});
      } catch (error) {
        failure = error;
      }
      cart = await request('cart.js');
      const total = sum(cart.items.filter(item => sameGroup(item) && (planId(item) === sourcePlan || planId(item) === targetPlan)));
      if (total !== expectedTotal) throw new Error(api.config.error);
      if (sum(sourceRows(cart)) < remaining) stalled = 0;
      else {
        stalled += 1;
        if (failure?.status && failure.status < 500 && failure.status !== 429) throw failure;
        if (stalled >= 3) throw failure || new Error(api.config.error);
      }
    }
    if (sum(cart.items.filter(item => sameGroup(item) && planId(item) === sourcePlan)) !== expectedSource || targetQuantity(cart) !== expectedTarget) throw new Error(api.config.error);
  };
  api.configureHooks({
    onBusy(busy) {
      document.querySelectorAll('.cart-aside__form').forEach(form => form.setAttribute('aria-busy', String(busy)));
      if (busy) {
        status('');
        locked = [...document.querySelectorAll('.cart-aside__form button, .cart-aside__form select')].map(node => ({node, disabled:node.disabled}));
        locked.forEach(({node}) => { node.disabled = true; });
      } else {
        locked.forEach(({node, disabled}) => { if (node.isConnected) node.disabled = disabled; });
        locked = [];
      }
    },
    onError(error) { status(error ? api.config.error : ''); }
  });
  const mutate = operation => api.run(async ({reconcile}) => {
    await operation();
    const cart = await reconcile({sections:true});
    render(cart, true);
    return cart;
  }).catch(() => {});
  const markRemoving = button => {
    const disabled = button.disabled;
    const busy = button.getAttribute('aria-busy');
    button.setAttribute('data-gs-removing', '');
    button.setAttribute('aria-busy', 'true');
    button.disabled = true;
    return () => {
      button.removeAttribute('data-gs-removing');
      if (busy === null) button.removeAttribute('aria-busy');
      else button.setAttribute('aria-busy', busy);
      button.disabled = disabled;
    };
  };
  const markUpgrading = button => {
    const disabled = button.disabled;
    const busy = button.getAttribute('aria-busy');
    const label = button.textContent;
    button.setAttribute('data-gs-upgrading','');
    button.setAttribute('aria-busy','true');
    button.disabled = true;
    button.textContent = button.dataset.loadingLabel || label;
    return () => {
      button.removeAttribute('data-gs-upgrading');
      if (busy === null) button.removeAttribute('aria-busy');
      else button.setAttribute('aria-busy',busy);
      button.disabled = disabled;
      button.textContent = label;
    };
  };
  document.addEventListener('gutsupp:purchase-state', event => { purchasing = Boolean(event.detail?.busy); });
  document.addEventListener('click', event => {
    const checkout = event.target.closest('a[name="checkout"], a[href="/checkout"], input[name="checkout"], button[name="checkout"]');
    if (checkout) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (purchasing || api.busy) return;
      api.run(async ({reconcile}) => {
        const cart = await reconcile({sections:false});
        if (cart.item_count) window.location.assign(root + 'checkout');
        else render(cart, true);
      }).catch(() => {});
      return;
    }
    const button = event.target.closest('.cart-aside__item-delete, .quantity__minus, .quantity__plus, [data-cart-upgrade], .type-button');
    const row = button?.closest('.cart-aside__item');
    if (!row) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (purchasing || api.busy || button.disabled || button.hasAttribute('data-gs-removing') || button.hasAttribute('data-gs-upgrading')) return;
    const quantity = Number(row.querySelector('.quantity__value')?.value || 1);
    const body = {id:row.dataset.itemKey, quantity};
    const deleting = button.matches('.cart-aside__item-delete');
    if (deleting) body.quantity = 0;
    else if (button.matches('.quantity__minus')) body.quantity = Math.max(0,quantity-1);
    else if (button.matches('.quantity__plus')) body.quantity = quantity+1;
    else if (button.matches('[data-cart-upgrade]')) body.selling_plan = upgradePlans[row.dataset.variantId] || Number(button.dataset.sellingPlan);
    else {
      const selected = row.querySelector('.type-subscriptions__plans');
      const plan = selected?.selectedOptions[0]?.dataset.plan || row.dataset.defaultSellingPlanId;
      body.selling_plan = button.classList.contains('type-button--subscribe') ? Number(plan) : null;
    }
    const restoreDeleteButton = deleting ? markRemoving(button) : null;
    const restoreUpgradeButton = button.matches('[data-cart-upgrade]') ? markUpgrading(button) : null;
    mutate(async () => {
      if (button.matches('[data-cart-upgrade], .type-button')) {
        await changePlan(row,body.selling_plan);
      } else if (row.dataset.aggregateParent === 'true') {
        const cart = await request('cart.js');
        const properties = canonical(JSON.parse(row.dataset.groupProperties || '{}'));
        const peers = cart.items.filter(item => String(item.variant_id) === row.dataset.variantId && planId(item) === row.dataset.sellingPlanId && canonical(item.properties) === properties);
        if (!peers.length) throw new Error(api.config.error);
        const updates = Object.fromEntries(peers.map((item,index) => [item.key,index === 0 ? body.quantity : 0]));
        await request('cart/update.js',{updates});
      } else await request('cart/change.js',body);
    }).finally(() => {
      if (restoreDeleteButton) restoreDeleteButton();
      if (restoreUpgradeButton) restoreUpgradeButton();
    });
  }, true);
  document.addEventListener('change', event => {
    const select = event.target.closest('.cart-aside__item .variant-select, .cart-aside__item .type-subscriptions__plans');
    if (!select) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (purchasing || api.busy) return;
    const row = select.closest('.cart-aside__item');
    const quantity = Number(row.querySelector('.quantity__value')?.value || 1);
    const option = select.selectedOptions[0];
    mutate(async () => {
      if (select.matches('.variant-select')) {
        await request('cart/change.js',{id:row.dataset.itemKey,quantity:0});
        await request('cart/add.js',{items:[{id:Number(option.dataset.id),quantity}]});
      } else await changePlan(row,Number(option.dataset.plan));
    });
  }, true);
  document.addEventListener('submit', event => {
    if (!event.submitter?.matches('[name="checkout"]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (purchasing || api.busy) return;
    api.run(async ({reconcile}) => {
      const cart = await reconcile({sections:false});
      if (cart.item_count) window.location.assign(root+'checkout');
      else render(cart,true);
    }).catch(() => {});
  }, true);
  window.addEventListener('pageshow', () => {
    window.setTimeout(() => {
      if (purchasing) return;
      const open = document.querySelector('.cart-aside')?.classList.contains('cart-aside--active') || location.pathname === root+'cart';
      api.run(async ({reconcile}) => render(await reconcile({sections:true}),open)).catch(() => {});
    },0);
  });
})();



